import React, { useRef, useState, useEffect } from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import { useSelector } from "react-redux";

import TaskList from "../task-list/task-list.component";
import RetroInput from "../../../retro/input/input.component";
import Box from "../../../retro/box/box.component";
import TaskSettings from "../../../task-settings/task-settings.component";

import { FaChevronDown } from "react-icons/fa";
import { BsGripHorizontal } from "react-icons/bs";

import {
  db,
  createNewTaskk,
  toggleStatus,
  changeStatusTypeName,
  changePhaseName,
} from "../../../../firebase/firebase.utils";

import "./status-type-list.styles.scss";

const StatusTypeList = ({
  currentSpaceId,
  currentStationId,
  status,
  tasks,
  index,
  stationTasksFL,
}) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const statusType = useSelector((state) => state.space.statusType);
  const [newTaskName, setNewTaskName] = useState("");
  const [inputName, setInputName] = useState("");
  const inputRef = useRef();
  const inputNameRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    createNewTaskk(
      currentSpaceId,
      currentStationId,
      status.id,
      newTaskName,
      currentUser.uid
    );
    inputRef.current.value = "";
    inputRef.current.blur();
  };

  const handleNameSubmit = (e) => {
    e.preventDefault();
    // if (!statusType) return;
    changePhaseName(
      currentSpaceId,
      currentStationId,
      status.id,
      inputNameRef.current.value
    );
  };

  useEffect(() => {
    setInputName(status.name);
  }, [status.name]);

  return (
    <Draggable draggableId={status.id} index={index}>
      {(provided) => (
        <div
          className="statusTypeList"
          {...provided.draggableProps}
          ref={provided.innerRef}
        >
          <div className="stl__header">
            <div className="stl__arrow">
              <FaChevronDown
                style={{
                  color: status.fontColor,
                  transform: status.open ? "" : "rotate(-90deg)",
                  filter: status.open ? "grayScale(0%)" : "grayScale(100%)",
                  opacity: status.open ? "1" : "0.5",
                }}
                onClick={() =>
                  toggleStatus(currentSpaceId, currentStationId, status.id)
                }
              />
            </div>
            <div className="stl__title">
              <form onSubmit={(e) => handleNameSubmit(e)}>
                <input
                  ref={inputNameRef}
                  value={inputName}
                  style={{
                    color: status.fontColor,
                    // textDecoration: `underline 4px solid ${status.fontColor}`,
                    filter: status.open ? "grayScale(0%)" : "grayScale(100%)",
                    opacity: status.open ? "1" : "0.5",
                  }}
                  onChange={(e) => setInputName(e.target.value)}
                />
              </form>
            </div>
            <div className="stl__menu">
              <div className="stl__drag" {...provided.dragHandleProps}>
                <BsGripHorizontal size="1.5em" />
              </div>
              <TaskSettings status={status} inputNameRef={inputNameRef} />
            </div>
          </div>
          <Box>
            <div className="stl__content">
              <Droppable droppableId={status.id}>
                {(provided, snapshot) => {
                  const style = {
                    backgroundColor: snapshot.isDraggingOver
                      ? "rgba(0,0,0,0.1)"
                      : "",
                    borderRadius: "8px",
                    display: status.open ? "" : "none",
                  };
                  return (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <div className="stl__taskList" style={style}>
                        {tasks?.map((task, index) => {
                          // if (task === undefined) return false;
                          return (
                            // <div
                            //   key={task.id}
                            //   task={task}
                            //   index={index}
                            //   status={task.phase}
                            // >
                            //   {task}
                            // </div>

                            <TaskList
                              key={task}
                              task={task}
                              index={index}
                              status={status}
                              stationTasksFL={stationTasksFL}
                            />
                          );
                        })}
                        {provided.placeholder}
                        {status.open && (
                          <div className="stl__newTask">
                            <form
                              onSubmit={(e) => {
                                handleSubmit(e);
                              }}
                            >
                              <div
                                onChange={(e) => setNewTaskName(e.target.value)}
                              >
                                <RetroInput
                                  ref={inputRef}
                                  placeholder="Add Task"
                                />
                              </div>
                            </form>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }}
              </Droppable>
            </div>
          </Box>
        </div>
      )}
    </Draggable>
  );
};

export default StatusTypeList;
